<template>
    <div class="carousel" tabindex="-1">
        <div class="carousel-grid" tabindex="-1">
            <movie-list v-for="(movie, key) in movies" :movie="movie" :key="movie.id" :index="key"></movie-list>
        </div>
    </div>
</template>


<script>
    import MovieTeaserDefault from './MovieTeaserDefault.vue';
    import {EventBus} from '../lib/EventBus';
    import Vue from 'vue';

    export default {

        components: {
            movieList: MovieTeaserDefault
        },

        data() {
            return {
                movies : [],
            }
        },

        mounted () {
            this.movies = this.getMovies();
            EventBus.$on('receive-movies', movies => {
                this.movies = this.getMovies();
            });
        },
        methods: {
            getMovies() {
                let movies = window.fetchMovies();
                if (movies.length > 0) {
                    let sortedMoviesByTimestamp = _.orderBy(movies, ['timestamp'], ['desc']);
                    movies = _.take(sortedMoviesByTimestamp, 8);
                }
                return movies;
            }
        },
    }
</script>




// WEBPACK FOOTER //
// NewMoviesList.vue?dd8cf7e4